<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()">返回</div>
      <div class="big_tit">修改支付密码</div>
    </div>
    <div class="wrap">
      <div class="write_new_pwd">
        <div class="write_box">
          <div class="wordBox">
            <input
              v-model="password"
              :type="passwordInp"
              placeholder="请输入原支付密码"
            />
          </div>
        </div>
        <div class="write_box">
          <div class="wordBox">
            <input
              v-model="npassword"
              :type="newpasswordInp"
              :placeholder="$t('setpaypwd.newpassword')"
            />
          </div>
        </div>
        <div class="write_box">
          <div class="wordBox">
            <input
              v-model="rpassword"
              :type="newpasswordInp"
              :placeholder="$t('setpwd.confirmnewpassword')"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="codeStatus"
      class="basic_btn"
      :class="
        rpassword != ''  && npassword != '' ? '' : 'no_touch'
      "
      @click="dxRevise"
    >
      {{ $t('setpwd.modify') }}
    </div>
    <div
      v-if="!codeStatus"
      class="basic_btn"
      :class="
        password != '' && rpassword != '' && npassword != '' ? '' : 'no_touch'
      "
      @click="oldRevise"
    >
      {{ $t('setpwd.modify') }}
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { CountDown } from 'vant'
  import Fetch from '../../utils/fetch'

  import { Popup } from 'vant'
  import { PasswordInput, NumberKeyboard } from 'vant'

  Vue.use(PasswordInput)
  Vue.use(NumberKeyboard)
  Vue.use(Popup)

  Vue.use(CountDown)

  export default {
    name: 'Setpwd',
    data() {
      return {
        showKeyboard: true,
        choose_tick: false,
        write_psd: false,
        time: 0,
        password: '',
        rpassword: '',
        npassword: '',
        mobile: '',
        ycmobile: '',
        passwordInp: 'password',
        newpasswordInp: 'password',
        codeStatus: true,
        psd_val: '',
        codeOK: false,
        code: '',
        is_send: false,
        nowInput: 1,
      }
    },
    created() {
      this.$parent.footer('user', false)
    },
    mounted() {
      document.getElementById('app').style.background =
        'linear-gradient(to bottom, #5674d3, #a8b6e5)'
      document.getElementById('app').style.marginBottom = '0px'
      Fetch('/user/info').then((r) => {
        this.mobile = r.data.mobile
        this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })
    },
    methods: {
      showWord(n) {
        n == 1 ? (this.nowInput = 1) : (this.nowInput = 2)
        this.psd_val = ''
        this.write_psd = true
      },
      onInput(key) {
        this.psd_val = (this.psd_val + key).slice(0, 6)
        if (this.psd_val.length == 6) {
          if (this.nowInput == 1) {
            this.npassword = this.psd_val
          } else {
            this.rpassword = this.psd_val
          }
          this.write_psd = false
        }
      },
      onDelete() {
        this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1)
      },
      cutType(n) {
        n == 1 ? (this.codeStatus = true) : (this.codeStatus = false)
        this.rpassword = ''
        this.npassword = ''
      },
      timeCall() {
        this.is_send = false
        this.time = 0
      },
      sendcode() {
        if (this.is_send) {
          return
        }

        this.is_send = true

        Fetch('/index/forgetpwd_email_code', {
          mobile: this.mobile,
        })
          .then(() => {
            this.time = 60 * 1000
            this.$toast({
              className: 'toastName',
              message: this.$t('setpwd.sendsuccessfully'),
            })
          })
          .catch(() => {
            this.is_send = false
          })
      },
      showPwd() {
        this.passwordInp == 'password'
          ? (this.passwordInp = 'text')
          : (this.passwordInp = 'password')
      },
      showNewsPwd() {
        this.newpasswordInp == 'password'
          ? (this.newpasswordInp = 'text')
          : (this.newpasswordInp = 'password')
      },
      dxRevise() {
        if (!this.npassword) {
          this.$toast(this.$t('setpaypwd.newpasswordcannotbeempty'))
          return false
        }

        if (this.npassword !== this.rpassword) {
          this.$toast(this.$t('setpaypwd.inconsistent'))
          return false
        }

        Fetch('/user/resetpaypwd_code', {
          code: this.code,
          npassword: this.npassword,
        }).then(() => {
          this.$toast({
            className: 'toastName',
            message: this.$t('setpwd.modifiedsuccessfully'),
          })

          sessionStorage.setItem('pwd', this.npassword)

          if (this.$route.query.redirect) {
            this.$router.replace(this.$route.query.redirect + '?change')
          } else {
            this.$router.replace('/safe')
          }
        })
      },
      oldRevise() {
        if (!this.password) {
          this.$toast(this.$t('setpaypwd.loginpasswordcannotbeempty'))
          return false
        }

        if (!this.npassword) {
          this.$toast(this.$t('setpaypwd.newpasswordcannotbeempty'))
          return false
        }

        if (this.npassword !== this.rpassword) {
          this.$toast(this.$t('setpaypwd.inconsistent'))
          return false
        }
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(this.npassword)) {
          this.$toast(this.$t('setpaypwd.pureNumber'))
          return false
        }
        if (!reg.test(this.rpassword)) {
          this.$toast(this.$t('setpaypwd.pureNumber'))
          return false
        }
        Fetch('/user/resetpaypwd', {
          passwd: this.password,
          npasswd: this.npassword,
        }).then(() => {
          this.$toast({
            className: 'toastName',
            message: this.$t('setpwd.modifiedsuccessfully'),
          })

          this.$router.replace('/safe')
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  .red_top_bg {
    height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    // background-position: center;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    background: linear-gradient(to left, #5674d3, #a8b6e5);
    height: 50px;
  }
  // .back_left {
  //   background: url(../../views/images/item/back_b.png) no-repeat center center;
  // }
  .big_tit {
    color: #fff;
  }
  .wrap {
    padding: 15px 20px 0 20px;
  }
  .no_touch {
    pointer-events: none;
  }

  .title {
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
      font-size: 18px;
      color: #000;
      font-weight: 400;
    }

    .cut {
      font-size: 12px;
      color: #3d96ff;
    }
  }

  .bd_tel {
    margin-top: 23px;
    color: #000;
    font-size: 14px;
    font-weight: 400;
  }

  .inp_box {
    display: flex;
    justify-content: space-between;
    height: 45px;
    margin-top: 9px;

    .inp {
      width: 195px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      border-radius: 2px;
      background-color: #ffffff;

      input {
        width: 100%;
        height: 22px;
        line-height: 22px;
        font-size: 16px;
      }
    }

    .getcode {
      flex: 1;
      margin-left: 10px;
      font-size: 16px;
      text-align: center;
      line-height: 45px;
      color: #ffffff;
      height: 45px;
      background: linear-gradient(
        90deg,
        rgba(228, 57, 46, 1) 0%,
        rgba(255, 77, 22, 1) 100%
      );
      border-radius: 8px;
    }

    .reset_code {
      background: rgba(228, 228, 228, 1);
      color: rgba(0, 0, 0, 0.3);
    }
  }

  .write_box {
    width: 100%;
    height: 45px;
    margin-top: 10px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    border-radius: 10px;
    background-color: #ffffff;

    input,
    .wordBox {
      width: 100%;
      height: 22px;
      line-height: 22px;
      font-size: 16px;
    }
  }

  .eye_bi {
    width: 21px;
    height: 25px;
    background: url(../images/user/eye2.png) no-repeat center center;
    background-size: 100% auto;

    &.eye {
      background: url(../images/user/eye1.png) no-repeat center center;
      background-size: 100% auto;
    }
  }

  .basic_btn {
    margin: 43px auto 0 auto;
  }

  .basic_btn {
    margin: 43px auto 0 auto;
    height: 45px;
    line-height: 45px;
    font-size: 16px;
    width: 90%;
    background: linear-gradient(to left, #756ff3, #399ffe);
    border-radius: 10px;
    color: #ffffff !important;
    text-align: center;
    margin-top: 20px !important;
  }
  /deep/ .van-password-input {
    margin: 50px 28px 0 28px;
  }

  /deep/ .van-hairline--left::after {
    border: 1px solid #ececec;
  }

  .van-password-input .van-password-input__security::after {
    border-radius: 0;
  }

  .keybord_box {
    height: 250px;
    background-color: #f0f0f0;
    margin-top: 35px;
    padding: 24px 12px 0 12px;
    .keybord {
      width: 361px;
      margin: 24px auto 0 atuo;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      text-align: center;
      .key_item {
        width: 115px;
        height: 44px;
        line-height: 44px;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 6px;
        background: rgba(255, 255, 255, 1);
        border-radius: 3px;
        &.no_bg {
          background: none;
        }
        &.x {
          color: #757880;
          font-weight: bold;
        }
      }
    }
  }
</style>
